import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { getLightBorder } from 'Components/utils';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import {
  ThreadParticipantAvatarGroup,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHeader/components/ThreadParticipantAvatarGroup';
import { DataValueMap } from 'Helpers/Testing';
import {
  ThreadSubject,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHeader/components/ThreadSubject';
import {
  useMobileThreadHeader,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHeader/components/MobileThreadHeader/useMobileThreadHeader';
import {
  MobileMessageInfoDrawer,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/MobileMessageInfoDrawer/MobileMessageInfoDrawer';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const useStyles = buildUseStyles('MobileThreadHeader', (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto',
    width: '100%',
    padding: theme.spacing(1, 0),
    gap: theme.spacing(1),
    ...getLightBorder(theme, { bottom: true }),
  },
}));

const MobileThreadHeader = ({
  className,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const {
    selectedThreadResource,
    clearSelectedThreadResource,
  } = useMessagesContext();

  const {
    messageInfoDrawerOpen,
    handleOpenMessageInfoDrawer,
    handleCloseMessageInfoDrawer,
  } = useMobileThreadHeader();

  return (
    <Box
      className={classNames(classes.root, className)}
      {...DataValueMap.init('messages-page-thread-header').build()}
    >
      <IconButton
        icon={ChevronLeftIcon}
        onClick={() => clearSelectedThreadResource()}
        {...DataValueMap.init('messages-page-thread-header-close').build()}
      />
      <ThreadSubject threadResource={selectedThreadResource} />
      <ThreadParticipantAvatarGroup />
      <IconButton
        className={classes.quickActionsIcon}
        color={'primaryGray5'}
        icon={MoreVertIcon}
        onClick={() => handleOpenMessageInfoDrawer()}
        {...DataValueMap
          .init('messages-page-thread-header-message-info-button')
          .build()}
      />
      <MobileMessageInfoDrawer
        open={messageInfoDrawerOpen}
        onClose={() => handleCloseMessageInfoDrawer()}
        threadResource={selectedThreadResource}
      />
    </Box>
  );
};

MobileThreadHeader.defaultProps = {
  className: '',
};

MobileThreadHeader.propTypes = {
  className: PropTypes.string,
};

export { MobileThreadHeader };
